<template>
    <div>
        <page-header>
            <template #breadcrumbs>
                <router-link to="/admin/routes">Маршруты</router-link> &raquo;
                <span>{{ item && item.name ? item.name : 'Новый маршрут' }}</span>
            </template>
            <h2>Маршрутный лист</h2>
        </page-header>
        <div class="card" v-if="item" v-disable-all="isReadonly">
            <div class="row my-3">
              <div class="col">
                <div class="form-group required">
                  <label class='control-label'>Название</label>
                  <div><input class="form-control"  required="required" v-model="item.name"/> </div>
                  <div class="invalid-msg" v-if="v$.item.name.$error">Введите данные</div>
                </div>
              </div>
            </div>  
            <EditRouteComponent v-bind:steps="item.stepsDto" 
                                v-bind:needSave="needSave" 
                                v-bind:routeId="item.id" 
            v-on:saveSteps="onSaveSteps($event)"/>
        </div>
        <div class="card-footer">
            <div class="float-right d-flex flex-wrap align-items-center">
                <button-component type="button"  class="btn btn-default m-2" v-if="!isReadonly" v-on:click="save">Сохранить</button-component>
                <button-component kind="secondary" type="button" class=" btn m-2" v-on:click="close">Закрыть</button-component>
            </div>
        </div>
    </div>
</template>

<script>
  import PageHeader from "../../../common/components/page/PageHeader";
  import API from "../../admin/api/routes";
  import Constants from "../../../common/constants";

  import {required} from "@vuelidate/validators";
  import {useVuelidate} from "@vuelidate/core";
  import EditRouteComponent from '../components/EditRouteComponent.vue';
  import disableAll from "../../../common/directives/disable-all";
  import ButtonComponent from "@/common/ui/ButtonComponent";
  import security from "../../../common/mixins/security";

  export default {
    name: "RouteCard",
    components: {
        ButtonComponent,
        PageHeader,
        EditRouteComponent
    },
    directives: {
      'disable-all': disableAll
    },
    mixins: [security],
    data() {
      return {
        id: this.$route.params.id,
        isReadonly: this.$route.params.action === 'view',
        item: {
          steps: []
        },
        needSave: 0
      };
    },
    created() {
      this.checkPermissions([Constants.RouteEdit, Constants.RouteView]);
      this.loadPage();
    },
    mounted() {

    },
    methods: {
      loadPage() {
        if (this.id > 0) {
          API.find(this.id).then((function (response) {
            var routeItem = response.data;
            this.nextStepOrderNum = routeItem.stepsDto[routeItem.stepsDto.length - 1].orderNum + 1;
            //routeItem.steps.forEach(st => {
            //  st.signers.forEach(s=>{
            //    s.roles = s.organization.organizationRoles.map((r)=>{return r.role})
            //       .map((o)=> {return {text: o.name, id: o.id} });
            //  });
            //});
            this.item = routeItem;
            console.log(this.item, '--------- route from routeCrad')
          }).bind(this));
        }
      },
      save() {
        this.v$.$touch();
        if (this.v$.$invalid) {
          Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей', 'error');
          return;
        }

        this.needSave += 1;
      },
      onSaveSteps(steps) {
        this.item.steps = steps;
        API.save(this.item).then(function (response) {
          Constants.alert.fire('Сохранение', response.data.message, response.data.success ? 'success' : 'error' );
        });
      },
      close() {
        this.$router.push({name: 'Routes'});
      }
    },
    setup: () => ({ v$: useVuelidate() }),
    validations () {
      return {
        item: {
          name: {
            required,
          }
        }
      }
    }
  }

</script>

<style lang="scss" scoped>
    @import '/src/assets/theme/default/colors.scss';

    tr.noBorder td {
      border: 0;
      width: 100%
    }

    .nav-tabs{
        .nav-item{
            .nav-link{
                padding-bottom: 16px;
                color: $black;
                font-weight: bold;
                border: none;
                border-bottom: 1px solid $blue-light;;
                &.active{
                    color: $blue-light;
                }
            }
        }
    }
    .form-group.required .control-label:after {
        content:" *";
        color:red;
    }
    .form-check.required .control-label:after {
        content:" *";
        color:red;
    }
    .invalid-msg {
        color:red;
        font-size: 0.75rem;
    }
    .card {
        padding: 24px;
        margin: 10px 24px 0 24px;
        border-radius: 24px;
        border: none;
        box-shadow: none;
        background-color: #fff;
    }

</style>